import { graphql } from 'gatsby';
import * as React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Layout } from '../components/layout';
import LegalNotice from '../components/LegalNotice/legalNotice';
import Seo from '../components/seo';

const isSandbox = process.env.GATSBY_ENV !== 'production';

const LegalNoticePage = ({ pageContext }) => {
  const { t } = useTranslation();

  if (isSandbox) {
    if (typeof window !== 'undefined') {
      window.location.replace('/');
    }
    return null;
  }

  return (
    <Layout>
      <Seo title={t('trans.imprint')} lang={pageContext.language} />
      <LegalNotice />
    </Layout>
  );
};
export default LegalNoticePage;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
